import * as els from './megamenuElements';

const toggleMegamenu = (trackGTM = true): void => {
  if (els.hamburgerElement && els.hamburgerIconElement) {
    els.hamburgerIconElement.classList.toggle('opened');
  }

  if (els.megamenuWrapperElement) {
    els.megamenuWrapperElement.classList.toggle('opened');
  }

  if (els.megamenuBackdropElements) {
    els.megamenuBackdropElements.forEach((element) => {
      element.classList.toggle('megamenu-backdrop--active');
    });
  }
  if (trackGTM && window.didomiOnReady !== undefined) {
    window.didomiOnReady.push(function didomiCallback() {
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({
          event: 'clickTo_navigation',
          menu: {
            type: 'menu',
          },
          link: {
            text: els.megamenuWrapperElement.classList.contains('opened') ? 'open' : 'close',
          },
        });
      }
    });
  }
};

const escTrigger = (event: KeyboardEvent) => {
  if (event.key === 'Escape' && els.megamenuWrapperElement.classList.contains('opened')) {
    toggleMegamenu();
    window.removeEventListener('keydown', escTrigger, false);
  }
};

export const Megamenu = (): void => {
  if (
    els.hamburgerElement &&
    els.hamburgerIconElement &&
    els.headerSearchElement &&
    els.megamenuCloseElement &&
    els.megamenuBackdropElements
  ) {
    // otevirani pres hamburger
    els.hamburgerElement.addEventListener('click', () => {
      toggleMegamenu();
    });

    // otevreni pres ikonu lupy
    els.headerSearchElement.addEventListener('click', () => {
      if (
        els.megamenuWrapperElement?.classList.contains('opened') &&
        els.megamenuSearchInputElement
      ) {
        els.megamenuSearchInputElement.focus();
      } else {
        toggleMegamenu(false);

        if (els.megamenuSearchInputElement) {
          els.megamenuSearchInputElement.focus();
        }
      }
    });

    // zavreni pres tlacitko zavrit v megamenu
    if (els.megamenuCloseElement) {
      els.megamenuCloseElement.addEventListener('click', () => {
        toggleMegamenu();
      });
    }

    // zavreni pres kliknuti na backdrop
    els.megamenuBackdropElements.forEach((element) => {
      element.addEventListener('click', () => {
        if (element.classList.contains('megamenu-backdrop--active')) {
          toggleMegamenu();
        }
      });
    });

    // zavreni pres zmáčknutí esc klávesy
    document.addEventListener('keydown', escTrigger);
  }
};

export default Megamenu;
